import type { ComponentProps } from "react";

import type { TableCell } from "@skilitics/designer-ui-components";
import type { FormatMessages } from "@skilitics/localization";

export type Column = {
  readonly id: keyof typeof formatStrings;
  readonly width: string;
  readonly align: ComponentProps<typeof TableCell>["align"];
};

export const columns: Column[] = [
  {
    id: "thumbnail",
    width: "140px",
    align: "center",
  },
  {
    id: "titleAndDescription",
    width: "540px",
    align: "left",
  },
  {
    id: "tags",
    width: "300px",
    align: "left",
  },
  {
    id: "modified",
    width: "350px",
    align: "left",
  },
  {
    id: "lock",
    width: "70px",
    align: "center",
  },
];

export const formatStrings = {
  thumbnail: {
    en: "",
  },
  titleAndDescription: {
    en: "Title & Description",
  },
  tags: {
    en: "Tags",
  },
  modified: {
    en: "Last Updated",
  },
  lock: {
    en: "",
  },
} satisfies FormatMessages;
